export const CHANGE_ROUTE = 'actionId/CHANGE_ROUTE'
export const SET_REDIRECT_ROUTE = 'actionId/SET_REDIRECT_ROUTE'
export const CHANGE_VARIANT_ROUTE_INDEX = 'actionId/CHANGE_VARIANT_ROUTE_INDEX'
export const SET_PREVIOUS_ROUTE = 'actionId/SET_PREVIOUS_ROUTE'
